import { useTheme, useMediaQuery } from "@mui/material";
import BillingDesktop from "./BillingDesktop";
import BillingMobile from "./BillingMobile";

export default function Billing() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <BillingMobile /> : <BillingDesktop />;
}
